import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Table, Image, Row, Col, Modal, Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { TextField, InputLabel, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { AllVendorTableHead } from "../superAdminVendorTable/firstPageTable/AllVendorTableHead";
import { AuthorizedUserProfilePage } from "../superAdminVendorTable/ProfilePageViewReusable/AuthorizedUserProfilePage";
import SlidingComponent from "../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import SuperAdminFlag from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminFlag";
import SuperAdminBlockUser from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminBlockUser";
import SuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
import SuperAdminSMS from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import SuperAdminCall from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import { BusinessHoursMultiplePopup } from "../../../superAdminReusable/reusablePopupSuperAdmin/BusinessHoursMultiplePopup";
import { SuperAdminVendorViewDetailsPopup } from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminVendorViewDetailsPopup";

import { get_vendor_single_rating_review } from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";

import isEmpty from "../../../../../store/validation/is-Empty";
import ChatWindow from "../../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";

const PendingVendorRatingReviewProfile = (props) => {
  let dispatch = useDispatch();
  const [showAdd, setShowAdd] = useState(false);
  const [pic, setPic] = useState(null);
  const handleChangeCode = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const uploadImage = (e) => {
    setPic(URL.createObjectURL(e.target.files[0]));
  };
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => setShowAdd(true);
  let history = useHistory();
  // const ratingReviewAction = (e) => {
  //   history.push("/superadminvendorsratingview");
  // };

  const ratingReviewAction = (data) => (e) => {
    dispatch(get_vendor_single_rating_review(data, onReviewSuccess(data)));
  };

  const onReviewSuccess = (data) => (e) => {
    history.push({
      pathname: "/superadminvendorsratingview",
      state: { data: data },
    });
  };

  const location = useLocation();
  const [vendorInfo, setVendorInfo] = useState({});

  useEffect(() => {
    setVendorInfo(location.state.data);
  }, [location]);

  const [state, setState] = useState({
    code: "",
    country: "",
    state: "",
    role: "",
    monday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 10),
        closing_time: new Date(2020, 1, 1, 12),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 16),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 19),
        closing_time: new Date(2020, 1, 1, 22),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 10),
          closing_time: new Date(2020, 1, 1, 12),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 16),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 19),
          closing_time: new Date(2020, 1, 1, 22),
          description: "Dinner",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 24),
          closing_time: new Date(2020, 1, 1, 4),
          description: "Midnight Munching",
        },
      ],
    },
    tuesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    wednesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    thursday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    friday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    saturday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    sunday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
  });
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              backIcon={true}
              link={"/superadminallpendingvendors"}
              displayText={"Back"}
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Vendor Profile</div>
                <Button
                  variant="danger"
                  className=" btn2 btn-lg"
                  onClick={handleShowAdd}
                >
                  + Add Restaurant User
                </Button>
              </div>
              <div className="enShadowBox p-0 w-100">
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <AllVendorTableHead />
                    </thead>
                    <tbody className="w-100 super-admin-all-vendor-main-table-body">
                      <tr className="w-100 p-0">
                        <td className="p-0 w-100">
                          <table className="w-100">
                            <tbody className="sd_body_css">
                              <tr className="sd_body_table-row">
                                <td style={{ width: "12%" }}>
                                  <div className="vendor-main-section-one">
                                    <div className="image-box">
                                      <div className="Image-box-section">
                                        <Image
                                          fluid
                                          alt="wait time"
                                          title="wait time"
                                          src={vendorInfo.logo_url}
                                        />
                                        <div className="inside-image-box-discout">
                                          <Image
                                            fluid
                                            alt="Discount Picture"
                                            title="Discount Picture"
                                            src={require("../../../../../assets/images/superadmin/discount.svg")}
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        <h5 className="font_16_m mt-2">
                                          #{vendorInfo.vendor_id}
                                        </h5>
                                      </div>
                                    </div>
                                    <div className="start-rating-review-box mt-2">
                                      <Image
                                        fluid
                                        alt="wait time"
                                        title="wait time"
                                        className="star-image-box mr-1"
                                        src={require("../../../../../assets/images/superadmin/star.svg")}
                                      />
                                      <h5 className="font_16_m d-flex align-items-center">
                                        4.2{" "}
                                        <div className="font_10_r ml-1">
                                          (528 reviews)
                                        </div>
                                      </h5>
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "12%" }}>
                                  <h3 className="font_20_m">
                                    {vendorInfo.restaurant_name}
                                  </h3>
                                </td>
                                <td style={{ width: "16%" }}>
                                  <div className="font_18_m">Kinza</div>
                                  {!isEmpty(vendorInfo.enquiry_email) &&
                                    vendorInfo.enquiry_email.map(
                                      (singleitem, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            <div className="font_18_m mb-2 mt-2">
                                              {singleitem}
                                            </div>
                                          </React.Fragment>
                                        );
                                      }
                                    )}
                                  {!isEmpty(vendorInfo.contact_detail) &&
                                    vendorInfo.contact_detail.map(
                                      (singleitem, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            <div className="font_18_m">
                                              {singleitem.country_code +
                                                " " +
                                                singleitem.mobile_no}
                                            </div>
                                          </React.Fragment>
                                        );
                                      }
                                    )}
                                </td>
                                <td style={{ width: "25%" }}>
                                  <div className="font_18_r">
                                    {vendorInfo.restaurant_address}
                                  </div>
                                </td>
                                <td style={{ width: "14%" }}>
                                  <div className="font_18_m">fine dine</div>
                                  <div className="font_18_r">italian</div>
                                  <div className="w-75">
                                    <hr />
                                    <div className="font_18_r d-flex align-items-center">
                                      <img
                                        className=" mr-2"
                                        height="20px"
                                        src={require("../../../../../assets/images/UserManagement/organic.svg")}
                                      />
                                      Organic
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "9%" }}>
                                  {/* {!isEmpty(vendorInfo.vendor) &&
                                    vendorInfo.vendor.map((value, index) => {
                                      return (
                                        <React.Fragment key={index}> */}
                                  <SlidingComponent
                                    name="has_admin_approved"
                                    currentState={
                                      vendorInfo.vendor &&
                                      vendorInfo.vendor.has_admin_approved
                                    }
                                    type={"checkbox"}
                                    toggleclass={
                                      "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                                    }
                                    toggleinputclass={
                                      "toggle__switch vendor-super-admin-toggle"
                                    }
                                    onChange={props.toggleFunction}
                                    // slidingonClick={this.onSelecttogglestatusChange(data)}
                                    defaultChecked={
                                      vendorInfo.vendor &&
                                      vendorInfo.vendor.has_admin_approved ===
                                        true
                                        ? true
                                        : false
                                    }
                                  />
                                  {/* </React.Fragment>
                                      );
                                    })} */}
                                </td>
                                <td style={{ width: "12%" }}>
                                  <div className="d-flex align-items-center justify-content-end mb-2">
                                    <Button
                                      variant="link"
                                      className="enIconBtn action_icon_padding"
                                      onClick={props.handleShowEdit}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/ActionImages/image/onboarding.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                    <Button
                                      variant="link"
                                      className="enIconBtn ml-2 action_icon_padding"
                                      onClick={ratingReviewAction(vendorInfo)}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/ActionImages/image/rating.svg")}
                                        alt="Rating"
                                        title="Rating"
                                        fluid
                                      />
                                    </Button>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-end">
                                    <Button
                                      variant="link"
                                      className="enIconBtn action_icon_padding"
                                      onClick={props.handleShowEdit}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/ActionImages/image/order.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                    <Button
                                      variant="link"
                                      className="enIconBtn ml-2 action_icon_padding"
                                      onClick={props.handleShowEdit}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/ActionImages/image/events.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                              <tr className="sd_accordion_body">
                                <td style={{ width: "20%" }}>
                                  <h5 className="font_18_b mb-3">
                                    Staff Management
                                  </h5>
                                  <Button
                                    variant="link"
                                    className="enIconBtn mr-3"
                                    onClick={props.handleShowFlag}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/staff.svg")}
                                      alt="View"
                                      title="View"
                                      fluid
                                    />
                                  </Button>
                                </td>
                                <td style={{ width: "20%" }}>
                                  <h5 className="font_18_b mb-3">Payouts</h5>
                                  <Button
                                    variant="link"
                                    className="enIconBtn mr-3"
                                    onClick={props.handleShowFlag}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/Receipt.svg")}
                                      alt="View"
                                      title="View"
                                      fluid
                                    />
                                  </Button>
                                </td>
                              </tr>
                              <tr className="sd_accordion_body">
                                <td style={{ width: "26%" }}>
                                  <h5 className="font_18_b mb-3">Contact</h5>
                                  <div className="d-flex align-items-center">
                                    <SuperAdminCall />
                                    {/* <ChatWindowClass /> */}
                                    {/* <Button
                                      variant="link"
                                      className="enIconBtn mr-3"
                                      onClick={props.handleShowFlag}
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/UserManagement/forum.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button> */}
                                    <SuperAdminSMS data={vendorInfo} />
                                    <SuperAdminNotification />
                                  </div>
                                </td>
                                <td style={{ width: "17%" }}>
                                  <BusinessHoursMultiplePopup
                                    monday={state.monday.multipleHours}
                                    tuesday={state.tuesday.multipleHours}
                                    wednesday={state.wednesday.multipleHours}
                                    thursday={state.thursday.multipleHours}
                                    friday={state.friday.multipleHours}
                                    saturday={state.saturday.multipleHours}
                                    sunday={state.sunday.multipleHours}
                                  />
                                  <h5 className="font_18_r">
                                    Closes: {moment().format("HH : mm A")}
                                  </h5>
                                  <div className="mt-2 font_18_r d-flex align-items-center">
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/clock.svg")}
                                      alt="View"
                                      title="View"
                                      fluid
                                      width="16px"
                                      className="mr-2"
                                    />
                                    {vendorInfo.seatingWaitingTime}
                                    <span className="text-red ml-2">
                                      {vendorInfo.seatingWaitingTime === "00-00"
                                        ? ""
                                        : "Wait"}
                                    </span>
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="font_18_b mb-4">City</div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.city}
                                  </h5>
                                </td>
                                <td style={{ width: "13%" }}>
                                  <div className="font_18_b mb-4">Location</div>
                                  <h5 className="font_18_r">
                                    {vendorInfo.area}
                                  </h5>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="font_18_b mb-4">
                                    Member Since
                                  </div>
                                  <h5 className="font_18_r">
                                    {moment(vendorInfo.createdAt).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </h5>
                                </td>
                                <td style={{ width: "24%" }}>
                                  <h5 className="font_18_b c_red mb-3">
                                    More Actions
                                  </h5>
                                  <div className="d-flex align-items-center">
                                    <SuperAdminFlag
                                      data={vendorInfo}
                                      actionCall="pending"
                                    />
                                    <SuperAdminBlockUser
                                      data={vendorInfo}
                                      actionCall="pending"
                                    />
                                    {/* <SuperAdminVendorViewDetailsPopup
                                      viewData={props.vendorData}
                                    /> */}
                                    <Button
                                      variant="link"
                                      className="enIconBtn mr-3 action_icon_padding"
                                    >
                                      <Image
                                        src={require("../../../../../assets/images/UserManagement/eye.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div className="p-4 d-flex justify-content-between align-items-center">
                  <div className="font_16_b">Authorized Users</div>
                  <NavLink to="/" variant="link" className="text-blue f10-500">
                    View All
                  </NavLink>
                </div>
                {!isEmpty(vendorInfo.point_of_contact) &&
                  vendorInfo.point_of_contact.map((singleitem, index) => {
                    return (
                      <React.Fragment key={index}>
                        <AuthorizedUserProfilePage userData={singleitem} />
                      </React.Fragment>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showAdd} onHide={handleCloseAdd} centered size="lg">
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24_500_HelveticaNeue">
            Add Authorized User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <Form>
            <Row>
              <Col md={12}>
                <div className="enUploadEditPic">
                  <div className="user-profile-image w-100 h-100">
                    <Image
                      fluid
                      className="w-100 h-100"
                      src={
                        pic
                          ? pic
                          : require("../../../../../assets/images/ActionImages/demoprofile.jpg")
                      }
                    />
                  </div>
                  <div className="enUploadIcon">
                    <input
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => uploadImage(e)}
                    />
                    <Image
                      src={require("../../../../../assets/images/UserManagement/picUpload.svg")}
                      alt="chairs"
                      title="chairs"
                      className="w-100 h-100"
                    />
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    label="Name"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    type="email"
                    label="Email Address"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    type="password"
                    label="password"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    type="password"
                    label="Confirm password"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Row>
                  <Col xs={4} className="pr-0">
                    <FormControl variant="outlined" className="w-100">
                      <Select
                        value={state.code}
                        onChange={handleChangeCode}
                        inputProps={{
                          name: "code",
                        }}
                      >
                        <option value={+91}>+91</option>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col xs={8}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Phone Number"
                        variant="outlined"
                        className="w-100"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-role">Role</InputLabel>
                    <Select
                      value={state.role}
                      onChange={handleChangeCode}
                      label="Role"
                      inputProps={{
                        name: "role",
                        id: "outlined-role",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="role">Role</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-country">country</InputLabel>
                    <Select
                      value={state.country}
                      onChange={handleChangeCode}
                      label="Country"
                      inputProps={{
                        name: "country",
                        id: "outlined-country",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="country">Country</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-state">State</InputLabel>
                    <Select
                      value={state.state}
                      onChange={handleChangeCode}
                      label="state"
                      inputProps={{
                        name: "state",
                        id: "outlined-state",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="state">State</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    label="City"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex align-items-center pt-5">
              <Button
                variant="outline-secondary"
                className="mr-4 px-5 py-2"
                onClick={handleCloseAdd}
              >
                Cancel
              </Button>
              <Button variant="danger" className="px-5  py-2" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default PendingVendorRatingReviewProfile;

class ChatWindowClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chat: false,
    };

    this.chatRef = React.createRef();
  }
  HandleChat = (e) => {
    this.setState({ chat: !this.state.chat });
  };

  openChatWindow = () => {
    this.chatRef.current.openNav();
  };
  render() {
    return (
      <div>
        <Button
          variant="link"
          className="enIconBtn mr-3"
          onClick={this.openChatWindow}
        >
          <Image
            src={require("../../../../../assets/images/UserManagement/forum.svg")}
            alt="View"
            title="View"
            fluid
          />
        </Button>
        <ChatWindow ref={this.chatRef} />
      </div>
    );
  }
}
